import db from "../driverappdb";

export const DropDetailsRepository = {
    hasDropDetails: async (dropId) => await db.dropdetailsdata2.where({ dropId: dropId } ).count() > 0
};